module.exports = __webpack_public_path__ + "img/menu-reports-icon.cfec2efb.svg";